// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-recent-payments/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { DollarSignIcon as ComponentIcon } from 'lucide-vue-next'
import { markRaw } from 'vue'

// Define the metadata object for the plugin
export const WidgetRecentPaymentsMeta: TWidgetMetaInfo = {
  name: 'Recent Payments',
  categories: ['Widget'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Displays information about the most recent payments.',
  externalDependencies: [],
}
